import { Model } from 'app/model/backendmodel';
import { AdobeExperiencePlatformCopySource } from 'app/model/pipeline/copysource/adobe-experience-platform.copysource';
import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { ValueAdapter } from '../../value.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AdobeExperiencePlatformCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        completedDateTimeStart: '*',
        completedDateTimeEnd: '*'
    }
})
export class AdobeExperiencePlatformCopySourceAdapter extends CopySourceAdapter<
    AdobeExperiencePlatformCopySource,
    Model.AdobeExperiencePlatformSource
> {
    protected override async _toResource(
        copySource: AdobeExperiencePlatformCopySource
    ): Promise<Model.AdobeExperiencePlatformSource> {
        const result: Model.AdobeExperiencePlatformSource = this.getCommonCopySourceProperties(
            copySource,
            'AdobeExperiencePlatformSource'
        );
        result.completedDateTimeStart = ValueAdapter.toResource(
            copySource,
            AdobeExperiencePlatformCopySource.COMPLETED_DATETIME_START
        );
        result.completedDateTimeEnd = ValueAdapter.toResource(
            copySource,
            AdobeExperiencePlatformCopySource.COMPLETED_DATETIME_END
        );
        return result;
    }

    protected override async _toModel(
        resource: Model.AdobeExperiencePlatformSource,
        copyActivity: CopyActivity
    ): Promise<AdobeExperiencePlatformCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            AdobeExperiencePlatformCopySource.MODEL,
            resource,
            copyActivity
        ) as AdobeExperiencePlatformCopySource;
        ValueAdapter.toModel(
            result,
            AdobeExperiencePlatformCopySource.COMPLETED_DATETIME_START,
            resource.completedDateTimeStart
        );
        ValueAdapter.toModel(
            result,
            AdobeExperiencePlatformCopySource.COMPLETED_DATETIME_END,
            resource.completedDateTimeEnd
        );
        return result;
    }
}
